<template>
  <div class="country-visa-strategy" v-if="countryStrategy">

    <div class="strategy-top">

      <div class="country-box" :style="{ 'backgroundImage': `url(${countryInfo.background_img}` }" v-if="countryInfo">
        <div class="country-info">
          <img :src="countryInfo.national_flag_img" alt="">
          {{ countryInfo.country }}办签攻略
        </div>
        <div class="close-icon" @click="onClose"></div>
      </div>

      <!-- 签证简介 -->
      <div class="visa-introduction">
        <div class="introduction-box">
          <div class="introduction-icon">
            <img :src="difficultyMap[countryStrategy.difficulty]" alt="">
          </div>
          <div class="visa-introduction-content">
            <div class="content-top">{{ countryStrategy.introduction }}</div>
            <div class="content-bottom">{{ countryStrategy.update_time }}</div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="nav-box">
      <div class="nav-list">
        <div 
          :class="['nav-item', currentVisaTypeId === info.visa_type_id ? 'active': '' ]"
          v-for="info in countryStrategy.information"
          :key="info.visa_type_id"
          @click="onStretchContent(info)"
          :id="`visaType${info.visa_type_id}`"
        >
          {{ info.visa_type }}
        </div>
        <div class="nav-active-bar" :style="{'left': `${layout.tabLeft}px`,}"></div>
      </div>
    </div>
    

    <div class="strategy-content" v-if="currentInfo">
      <!-- 免签 -->
      <needless-form v-if="currentVisaTypeId === 1" :info="currentInfo"></needless-form>

      <!-- 落地签 --> 
      <arrival-form v-else-if="currentVisaTypeId === 2" :info="currentInfo"></arrival-form>

      <!-- 过境签 -->
      <transit-form v-else-if="currentVisaTypeId === 3" :info="currentInfo"></transit-form>

      <!-- 入台签 -->
      <taiwan-form v-else-if="currentVisaTypeId === 8" :info="currentInfo"></taiwan-form>

      <!-- 普通签 -->
      <normal-form v-else :info="currentInfo"></normal-form>
    </div>

  </div>
</template>


<script>
import needlessForm from './components/strategy-visa-type-form/needless-form.vue';
import arrivalForm from './components/strategy-visa-type-form/arrival-form.vue';
import transitForm from './components/strategy-visa-type-form/transit-form.vue';
import taiwanForm from './components/strategy-visa-type-form/taiwan-form.vue';
import normalForm from './components/strategy-visa-type-form/normal-form.vue';
import Http from '@/libs/http';

export default {
  components: {
    needlessForm,
    arrivalForm,
    transitForm,
    taiwanForm,
    normalForm,
  },
  data() {
    return {
      countryStrategy: undefined,
      difficultyMap: {
        0: require('../../../assets/imgs/country/strategy/D.png'),
        1: require('../../../assets/imgs/country/strategy/D.png'),
        2: require('../../../assets/imgs/country/strategy/C.png'),
        3: require('../../../assets/imgs/country/strategy/B.png'),
        4: require('../../../assets/imgs/country/strategy/A.png'),
        5: require('../../../assets/imgs/country/strategy/S.png'),
      },
      currentVisaTypeId: 0, // 当前的visa_type_id
      countryInfo: undefined,
      layout: {
        tabLeft: 0,
      },
    };
  },
  created() {
    this.init();
  },
  computed: {
    currentInfo() {
      if (!this.countryStrategy || !this.countryStrategy.information) return;
      return this.countryStrategy.information.find(info => info.visa_type_id === this.currentVisaTypeId);
    },
  },
  watch: {
    currentVisaTypeId: {
      handler(val) {
        if (!val) return; 
        this.$nextTick(() => {
          // 设置选中条
          const itemEl = document.querySelector(`#visaType${val}`);
          if (!itemEl) return;
          this.layout.tabLeft = itemEl.offsetLeft + itemEl.offsetWidth / 2 - 15;
        });
      },
    },
  },
  methods: {
    async init() {
      if (!this.$route.params.id) return; 

      await this.getCountryInfo(this.$route.params.id);
      this.getCountryStrategyDetail();
    },
    getCountryInfo(id) {
      return Http.post('/sys/visa_country_query', {
        visa_country_id: +id,
      }).then((res) => {
        this.countryInfo = res;
      }).catch(() => {
      });
    },
    getCountryStrategyDetail() {
      Http.post('/sys/visa_strategy_batch_query', {
        visa_country_id: this.countryInfo.visa_country_id,
      }).then((data) => {
        this.countryStrategy = data.visa_strategy;
        // 设置默认值
        if (this.countryStrategy && this.countryStrategy.information) {
          this.currentVisaTypeId = this.countryStrategy.information[0].visa_type_id;
        }
      });
    },
    onStretchContent(info) {
      if (!info) return; 
      this.currentVisaTypeId = info.visa_type_id;
      
    },
    onClose() {
      this.$router.back();
    },

  },
};

</script>


<style lang="less" scoped>
.country-visa-strategy {
  width: 1120px;
  margin: 0 auto;
  margin-bottom: 108px;
  >div {
    margin-top: 12px;
  }
  .strategy-top {
    background-color: #fff;
    .country-box {
      position: relative;
      height: 300px;
      width: 100%;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% auto;
      .country-info {
        display: flex;
        align-items: center;
        font-size: 32px;
        color: #FFFFFF;
        line-height: 45px;
        font-weight: 600;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 32px;
        >img {
          width: 36px;
          height: 24px;
          margin-right: 16px;
        }
      }
      .close-icon {
        position: absolute;
        top: 30px;
        right: 26px;
        width: 32px;
        height: 32px;
        background: rgba(0,0,0,0.4);
        backdrop-filter: blur(10px);
        font-size: 16px;
        color: #fff;
        cursor: pointer;
        &:hover {
          background: rgba(0,0,0,0.2);
        }
        &::before, &::after {
          content: '';
          background-color: #fff;
          display: inline-block;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          margin: auto;
        }
        &::before {
          content: '';
          width: 2px;
          height: 16px;
          transform: rotate(45deg);
        }
        &::after {
          content: '';
          width: 2px;
          height: 16px;
          transform: rotate(-45deg);
        }
      }
    }

    .visa-introduction {
      padding: 16px;
      .introduction-box {
        padding: 16px 0;
        display: flex;
        align-items: stretch;
        background: linear-gradient( 270deg, #FBFCFF 0%, #F4F9FF 100%);
        border-radius: 2px;
        .introduction-icon {
          flex-shrink: 0;
          padding: 0 66px;
          border-right: 1px solid #E9EEF2;
          >img {
            width: 54px;
            height: 58px;
          }
        }

        .visa-introduction-content {
          flex: 1;
          padding: 4px 16px 0 16px;
          .content-top {
            overflow : hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 16px;
            color: #2F333D;
            line-height: 24px;
          }
          .content-bottom {
            margin-top: 8px;
            font-size: 12px;
            color: #91999F;
            line-height: 12px;
          }
        }
      }

    }

  }
  
  .nav-box{
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.06);
    border-radius: 2px;
    overflow: hidden;
    .nav-list{
      height: 60px;
      width: 100%;
      position: relative;
      display: flex;
      padding: 0 20px;
      border-bottom: 1px solid #F0F0F0;
      .nav-item{
        color: #6F6F6F;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-left: 32px;
        &:first-child {
          margin-left: 0;
        }
        &.active{
          color: #599FFF;
          font-weight: 600;
        }
        
      }
      .nav-active-bar{
        position: absolute;
        bottom: 0;
        width: 30px;
        height: 4px;
        border-radius: 1px;
        background: #599fff;
        transition: 0.2s all;
      }
    }
  }

  .strategy-content {
    
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/country/country-visa-strategy/country-visa-strategy.vue